import { useEffect, useState } from "react";
import CameraIcon from "../../assets/icons/CameraIcon";
import useLivenessCheck from "../../customHooks/useLivenessCheck";
import CustomModal from "../Modal/CustomModal";
import styles from "./styles.module.css";
import CloseIcon from "../../assets/icons/CloseIcon";
import useUserValidated from "../../customHooks/useUserValidated";
import BvnValidationErrorPopup from "../BvnValidationErrorPopup";
import Loader from "../Loader";
import { LivePhotoCardProps } from "../../models/IEnums.model";
import apiHooks from "../../customHooks/apis";

const TakeLivePhotoCard: React.FC<Partial<LivePhotoCardProps>> = ({
  label,
  hideLabel,
  required,
  getFileUrl,
}) => {
  const { useUserDetails } = apiHooks;
  const { userDetails } = useUserDetails();
  const {
    status,
    setStatus,
    startLivenessCheck,
    snapShot,
    setSnapShot,
    setUploadedImageUrl,
    uploadedImageUrl,
    loggingLiveness,
  } = useLivenessCheck();
  const { handleIsValidated } = useUserValidated();
  const [showDisclaimer, setShowDisclaimer] = useState<boolean>(false);
  const validationType = localStorage.getItem("validationType");
  const { firstName, lastName } = userDetails;
  const fullName = `${firstName || ""} ${lastName || ""}`.trim();

  const handleRemoveImage = () => {
    getFileUrl("");
    handleIsValidated(false);
    setSnapShot("");
    setUploadedImageUrl('')
  };

  const handleCtrlLivenessCheck = () => {
    startLivenessCheck();
  };

  const handleCloseModal = () => {
    setStatus("");
    setShowDisclaimer(false);
  };

  const handleClickBtns = (text: string) => {
    if (text !== "Cancel") handleCtrlLivenessCheck();
    setShowDisclaimer(false);
  };

  useEffect(() => {
    getFileUrl(uploadedImageUrl);
  }, [uploadedImageUrl]);

  if (validationType === "bvn") return <></>;
  if (loggingLiveness) return <Loader />;
  return (
    <>
      {snapShot ? (
        <div className={styles.userImageWrapper}>
          <img src={snapShot} alt={fullName} className={styles.userImage} />
          <button
            type="button"
            className="bg-transparent"
            onClick={handleRemoveImage}
          >
            <CloseIcon fill="red" />
          </button>
        </div>
      ) : (
        <div className={styles.cardWrapper}>
          {!hideLabel && (
            <span className={styles.cardLabel}>
              {label || "Take a live photo"}
              {required && <strong className="text-danger">*</strong>}
            </span>
          )}
          <div
            className={styles.cardBody}
            onClick={() => setShowDisclaimer(true)}
          >
            <span>
              Take a <br /> live photo
            </span>
            <CameraIcon fill="#CAC2C3" />
          </div>
        </div>
      )}
      <CustomModal
        show={showDisclaimer}
        modalTitle={!!status ? "Take live picture" : "Disclaimer"}
        onClickClose={handleCloseModal}
      >
        {showDisclaimer && (
          <BvnValidationErrorPopup
            btnTexts={["Cancel", "Proceed"]}
            onClickBtn={handleClickBtns}
            redText="Please keep your eyes open during the scan so we can capture your biometric details correctly; it only takes a second."
            message="To help keep your account safe, we’ll need to scan your face to confirm your identity."
          />
        )}
      </CustomModal>
    </>
  );
};

export default TakeLivePhotoCard;
